import React, { useEffect, useMemo } from 'react';

import { Link, useLocation, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import AuthStore from 'auth-store';

import GenericDetails from 'partial/components/GenericDetails';

import {
  PENDING_SETTLEMENT_FORMAT,
  SUCCESS_SETTLEMENT_FORMAT,
} from '../constants';
import { useSelectedBillerSettlement } from '../hooks';

function ViewBillerSettlement() {
  const location = useLocation();
  const { merchant_id, settlement_id } = useParams();
  const [isLoading, settlement, fetchData] = useSelectedBillerSettlement();
  const userRole = AuthStore.get('_role');
  const initData = useMemo(() => location.state || settlement, [
    location,
    settlement,
  ]);

  useEffect(() => {
    fetchData(merchant_id, settlement_id);
  }, [fetchData, merchant_id, settlement_id]);

  return (
    <div className="flex flex-col h-full bg-white rounded-xl shadow overflow-y-auto p-5 m-5">
      <Link
        className="flex items-center font-medium text-base space-x-2 pb-3 text-primary-800"
        to="/settlement"
      >
        <FaArrowLeft />
        <span>Back</span>
      </Link>
      <div className="border-b text-lg font-medium">
        {initData?.request_ref_no}
      </div>
      <div className="mt-5">
        <GenericDetails
          data={initData}
          format={PENDING_SETTLEMENT_FORMAT[userRole]}
          isLoading={isLoading}
        />
      </div>
      {initData?.settlement_status === 'success' && (
        <div className="border-t pt-5 mt-5">
          <span className="font-medium text-gray-500 text-lg">
            Settlement Details
          </span>
          <div className="my-8">
            <GenericDetails
              data={initData}
              format={SUCCESS_SETTLEMENT_FORMAT}
              isLoading={isLoading}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewBillerSettlement;
